// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"fa8e5f0e","357":"105a98ba","376":"4170f515","749":"e0003285","788":"0dfe3c23","816":"c1401508"}[chunkId] + ".chunk.js";
};